const dataAccessMethods = require('../../../dataAccessMethods');
const { config } = require('@sstdev/lib_metadata-config');
const Blockly = require('blockly');
const arrayFromCommaSeparatedValues = require('../../../helpers/arrayFromCommaSeparatedValues');
const convertToBoolean = require('../../../helpers/convertToBoolean');
const { addSecurityModifiersToBlock } = require('../../../helpers/blockInitMethods');
const DelegatingMdcBlockGroup = require('../_DelegatingMdcBlockGroup');
const hNodeTypes = require('./types');
class Form extends DelegatingMdcBlockGroup {
    constructor(hNodeTypeGroup, categorySpec, color, subset = '') {
        super(hNodeTypeGroup, categorySpec, color, subset);
        super.types = hNodeTypes;
    }
    addCodeGeneratorCustom(code, blocklyBlock, hNodeType) {
        let dropdownNamespace = blocklyBlock.getFieldValue('namespace');
        let dropdownRelation = blocklyBlock.getFieldValue('relation');
        code.namespace = dropdownNamespace;
        code.relation = dropdownRelation;

        if (hNodeType === 'Form') {
            code.retainParentContext = convertToBoolean(blocklyBlock.getFieldValue('retainParentContext'));
            code.allowRecordDeactivation = convertToBoolean(blocklyBlock.getFieldValue('allowRecordDeactivation'));
            code.keepOpenAfterSubmit = convertToBoolean(blocklyBlock.getFieldValue('keepOpenAfterSubmit'));
        }

        if (hNodeType === 'Transaction') {
            code.unknownTagAction = blocklyBlock.getFieldValue('unknownTagAction');
            code.matchProperties = arrayFromCommaSeparatedValues(blocklyBlock.getFieldValue('matchProperties'));
            code.transactionType = blocklyBlock.getFieldValue('transactionType');
            code.beepForNewReads = convertToBoolean(blocklyBlock.getFieldValue('beepForNewReads'));
            // Transactions are always new unless we implement editing of history - which sounds like a horrible idea.
            code.forAction = 'new';
        }
        if (hNodeType === 'SingleRecordForm') {
            code.forAction = blocklyBlock.getFieldValue('forAction');
            //If we have a splash record, single record forms should not simply assume to get a single record tenant-wide
            //Instead, this allows it to filter its record by tenant AND the splash record as (foreign) key, and THEN assume there is only 1 result.
            // E.g. MDC: after selecting a useCaseVersion to edit, display that record in the single Record form.
            code.filterBySplashRecord = convertToBoolean(blocklyBlock.getFieldValue('filterBySplashRecord'));
        }
        if (hNodeType === 'SubForm') {
            addSecurityModifiersToCode(code, blocklyBlock);
        }
        return JSON.stringify(code);
    }

    addToBlocksCustom(color, blocklyBlock, hNodeType, mdcBlock, topInput) {
        let blockId = blocklyBlock.id;
        let workspace = blocklyBlock.workspace;
        topInput
            .appendField('  Namespace:')
            .appendField(new Blockly.FieldDropdown(dataAccessMethods.getNamespaces), 'namespace')
            .appendField('  Relation:')
            .appendField(
                new Blockly.FieldDropdown(() => dataAccessMethods.getRelations(workspace, blockId)),
                'relation'
            );

        if (hNodeType === 'Form') {
            const line2OfInput = blocklyBlock
                .appendDummyInput()
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField('  Retain parent context:')
                .appendField(new Blockly.FieldCheckbox(), 'retainParentContext');
            line2OfInput
                .appendField('  Allow Record Deactivation:')
                .appendField(new Blockly.FieldCheckbox(), 'allowRecordDeactivation');
            line2OfInput
                .appendField('  Keep Open After Submit:')
                .appendField(new Blockly.FieldCheckbox(), 'keepOpenAfterSubmit');
        }
        if (hNodeType === 'Transaction') {
            topInput.appendField('  Type:').appendField(new Blockly.FieldTextInput(), 'transactionType');
            blocklyBlock
                .appendDummyInput()
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField('  Match scanned values with')
                .appendField(new Blockly.FieldTextInput('tagId'), 'matchProperties')
                .appendField('  Unknown Tag Action: ')
                .appendField(new Blockly.FieldDropdown(config.unknownTagActions), 'unknownTagAction')
                .appendField('  Beep For New Reads:')
                .appendField(new Blockly.FieldCheckbox(), 'beepForNewReads');
            blocklyBlock.setInputsInline(false);
        }
        if (hNodeType === 'SingleRecordForm') {
            let actionsDropdown = new Blockly.FieldDropdown(config.formActions);
            //set a default value
            actionsDropdown.setValue('edit');
            blocklyBlock
                .appendDummyInput()
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField('  For Action:')
                .appendField(actionsDropdown, 'forAction')
                .appendField('  Filter By Splash Record:')
                .appendField(new Blockly.FieldCheckbox(), 'filterBySplashRecord');
        }
        if (hNodeType !== 'SubForm') {
            blocklyBlock
                .appendStatementInput('formButtons')
                .setCheck(['formButton', 'actionElement'])
                .appendField('Form Buttons:');
        }

        blocklyBlock
            .appendStatementInput('children')
            .setCheck(mdcBlock.allowedChildrenTypes)
            .appendField('FormElements:', 'childrenField');

        if (hNodeType === 'SubForm') {
            addSecurityModifiersToBlock(blocklyBlock, hNodeType);
            blocklyBlock.setNextStatement(true, ['form']);
        } else {
            blocklyBlock.setNextStatement(false);
        }
    }
}

function addSecurityModifiersToCode(code, block) {
    const childrenSecurityModifiers = Blockly.JavaScript.valueToCode(
        block,
        'securityModifier',
        Blockly.JavaScript.ORDER_NONE
    );
    if (childrenSecurityModifiers) {
        // Copy security modifiers over to the code object.
        Object.assign(code, JSON.parse(childrenSecurityModifiers));
    }
}

module.exports = Form;
